import {endpoint} from '~/api';
import {IFeature} from '~/modules/Dashboard/models/Feature';
import {IPerformanceQuery} from '~/modules/Dashboard/reducer';
import {IPerformance, IPerformanceDimension, PerformanceType} from './models/Performance';
import { toUTCWithLocalTime } from '~/lib/date';

export const getPerformance = ({
    performanceType,
    dimensions,
    from,
    to,
    granularity,
    sellerId,
    agencyId,
}: IPerformanceQuery) => {
    const body: Record<string, unknown> = {
        interval: `${toUTCWithLocalTime(from)?.toISOString()}/${toUTCWithLocalTime(to)?.toISOString()}`,
        granularity: granularity,
    };
    if (agencyId != null) {
        body['agencyId'] = agencyId;
    }
    if (performanceType === PerformanceType.PAYER) {
        body['includePayer'] = true;
        if (sellerId !== undefined && sellerId !== null) {
            body['sellerId'] = sellerId;
        }
    } else if (performanceType && dimensions) {
        if (performanceType === PerformanceType.AGENCY) {
            body['agency'] = dimensions;
        } else if (performanceType === PerformanceType.SELLER) {
            body['sellerIds'] = dimensions;
        } else if (performanceType !== PerformanceType.SUMMARY) {
            body[performanceType] = dimensions;
        }
    }
    return endpoint.post<IPerformance[]>('/performance', body).then(r => r.data || []);
};

export const getPerformanceDimensions = ({performanceType, from, to}: IPerformanceQuery) => {
    const url = new URLSearchParams();
    url.set('start', toUTCWithLocalTime(from)?.toISOString());
    url.set('end', toUTCWithLocalTime(to)?.toISOString());
    return endpoint.get<IPerformanceDimension[]>(`/performance/${performanceType}?${url.toString()}`).then(r => r.data || []);
};

export const fetchFeatures = () =>
    endpoint.get<IFeature[]>('/features').then(r => r.data.map(value => sessionStorage.setItem(value.key, value.value.toString())));
